<template>
    <div style="width: 100%;background-color: white;border-top: 1px solid #c0c0c0;;border-bottom: 1px solid #c0c0c0">
        <div class="card-list" style="position: relative;background-color: white;width: calc(100% - 20px);margin: 9px;border: 1px solid #c0c0c0;margin-bottom: 10px;float: left;">
            <div class="x" @click="$emit('exit')"></div>
            <div style="display: flex;justify-content: space-around;">
                <Card :card="item" @editCard="$emit('editCard')" @removeCard="$emit('removeCard')" />
            </div>
        </div>
    </div>
</template>

<script>

import Card from '../components/Card.vue'

export default {
    props: ['item'],
    components: {
        Card
    },
    mounted () {
        console.log('this.item',this.item);
    }
}

</script>

<style>

</style>